import React from 'react';
import FAQAccordion from './FAQAccordion';
import { MessageCircle } from 'lucide-react';

const faqData = {
  coursParticuliers: {
    title: 'Cours Particuliers',
    questions: [
      {
        question: 'Quels sont les tarifs des cours particuliers ?',
        answer: 'Nos cours sont proposés à 25€ pour 1 heure et 40€ pour 2 heures. Le format 2 heures est recommandé car il permet d\'approfondir davantage les notions et offre un meilleur rapport qualité/prix.'
      },
      {
        question: 'Comment se déroulent les cours en visioconférence ?',
        answer: 'Les cours se déroulent sur la plateforme Wooskill, qui offre tous les outils nécessaires pour un apprentissage efficace : tableau blanc interactif, partage d\'écran, chat, etc.'
      },
      {
        question: 'Comment rejoindre la visioconférence ?',
        answer: 'Lors du paiement, vous recevez un mail contenant le lien de la visio qui vous redirigera directement sur la session. Vous pouvez également y accéder via votre espace personnel Wooskill dans la section "Mes prochains rendez-vous.'
      },
      {
        question: 'Comment sont personnalisés les cours ?',
        answer: 'Avant chaque première séance, nous évaluons votre niveau et vos besoins spécifiques via le chat Wooskill. Le contenu est ensuite adapté pour répondre à vos objectifs, que ce soit pour renforcer certaines notions ou préparer des examens.'
      },
      {
        question: 'Quels supports sont fournis après le cours ?',
        answer: 'Après chaque séance, vous recevez une fiche de synthèse personnalisée et des exercices pour vous entraîner via la plateforme Wooskill.'
      }
    ]
  },
  flashcards: {
    title: 'Flashcards SES',
    questions: [
      {
        question: 'Quel est le contenu de la boîte de Flashcards Notions-Définitions SES Terminale ?',
        answer: 'La boîte Flashcards Notions-Définitions SES Terminale contient 110 cartes couvrant l\'intégralité du programme de Terminale, organisées par chapitre avec un code couleur distinct. Chaque carte est soigneusement conçue pour faciliter la mémorisation des concepts essentiels.'
      },
      {
        question: 'Quel est le prix de la boîte Flashcards Notions-Définitions SES Terminale ?',
        answer: 'La boîte Flashcards Notions-Définitions SES Terminale est proposée au prix de 15,99€. Le prix inclut la boîte de rangement et les 110 cartes plastifiées de qualité premium.'
      },
      {
        question: 'Dans combien de temps vais-je recevoir ma boîte de Flashcards ?',
        answer: 'Dès le paiement de votre commande, il faut compter 2 à 4 jours ouvrés pour recevoir votre boîte de Flashcards ! Nous préparons et envoyons chaque colis à la main pour le moment. Ne vous inquiétez pas, on vous préviendra du moindre problème !'
      },
      {
        question: 'Les cartes sont-elles résistantes ?',
        answer: 'Oui, les cartes sont plastifiées pour une durabilité maximale et résister à toutes vos sessions de révision intensives. Le format est pratique et transportable pour réviser n\'importe où.'
      },
      {
        question: 'Quels chapitres sont couverts ?',
        answer: 'Les cartes couvrent tous les chapitres du programme évaluables pour le baccalauréat : Croissance économique, Commerce international, Chômage, Europe, Structure sociale, Mobilité sociale, Travail-Emploi, Engagement politique et Environnement.'
      }
    ]
  },
  sujetsBac: {
    title: 'Sujets de Bac',
    questions: [
      {
        question: 'Les sujets sont-ils corrigés ?',
        answer: 'Oui, chaque sujet est accompagné d\'une correction vidéo détaillée disponible sur notre chaîne YouTube. Vous pouvez télécharger l\'énoncé en PDF et suivre la correction pas à pas. Par défaut, et s\'il n\'y a pas encore de correction, le bouton redirige vers notre chaîne YouTube. Patience, les corrections arrivent !'
      },
      {
        question: 'Comment sont organisés les sujets ?',
        answer: 'Les sujets sont classés par type (Dissertation, EC1, EC2, EC3), par chapitre, par année, par session et par centre d\'examen. Un code couleur permet de différencier les types de sujet et vous pouvez utiliser les filtres pour trouver facilement les sujets qui vous intéressent. Vous pouvez également rechercher les sujets à travers la barre de recherche.'
      },
      {
        question: 'Les sujets sont-ils à jour ?',
        answer: 'Oui, nous mettons régulièrement à jour notre base de données avec les derniers sujets de bac, y compris les sujets de 2024. Ce sont les sujets officiels.'
      },
      {
        question: 'Comment accéder aux corrections ?',
        answer: 'Les corrections sont disponibles en format vidéo sur notre chaîne YouTube. Un lien direct vers la correction est fourni avec chaque sujet.'
      }
    ]
  },
  ressources: {
    title: 'Ressources Gratuites',
    questions: [
      {
        question: 'Quels types de ressources sont disponibles ?',
        answer: 'Nous proposons des fiches de révision, des méthodes pour le bac, et des plans détaillés. Les fiches sont des synthèses claires et structurées, les méthodes sont des guides pour réussir les épreuves, et les plans sont des modèles pour les sujets type bac.'
      },
      {
        question: 'Comment accéder aux ressources ?',
        answer: 'Toutes les ressources sont accessibles gratuitement depuis la section "Ressources". Il suffit de vous connecter avec votre compte pour les télécharger en format PDF.'
      },
      {
        question: 'À quelle fréquence ajoutez-vous de nouvelles ressources ?',
        answer: 'Nous ajoutons régulièrement de nouvelles ressources pour couvrir l\'ensemble du programme et répondre aux besoins des élèves. N\'hésitez pas à revenir fréquemment pour ne pas louper les nouvelles ressources !'
      },
      {
        question: 'Les ressources sont-elles adaptées à mon niveau ?',
        answer: 'Oui, les ressources sont organisées par niveau (Première/Terminale), par type (Fiches/Méthodes/Plans), par thème (Économie/Sociologie/Regards Croisés) et par chapitre. Chaque ressource est conçue pour être claire et accessible, tout en respectant les exigences du programme.'
      }
    ]
  }
};

const FAQSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-[#9a6ebd]/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#9a6ebd]/10 rounded-full mb-4">
            <MessageCircle className="w-8 h-8 text-[#9a6ebd]" />
          </div>
          <h2 className="text-3xl font-bold text-[#323c5f]">
            Questions Fréquentes
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
            Vous avez des questions ? Nous avons les réponses !
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {Object.entries(faqData).map(([key, section]) => (
            <div key={key} className="bg-white rounded-2xl shadow-lg p-6 border-2 border-[#ceace8] hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-xl font-semibold text-[#323c5f] mb-6 pb-4 border-b border-[#9a6ebd]/20">
                {section.title}
              </h3>
              <FAQAccordion questions={section.questions} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;